(function () {
  if (/iPhone|iPad|iPod|Android/i.test(navigator.userAgent)) return;

  const hero = document.querySelector('.hero');
  const img = document.querySelector('.hero__media');
  if (!hero || !img) return;

  function update() {
    const rect = hero.getBoundingClientRect();
    if (rect.bottom < 0 || rect.top > window.innerHeight) return;
    // 只在向下滚动时才抵消位移，初始不动
    const offset = Math.max(0, -rect.top);
    img.style.transform = 'translate3d(0, ' + offset + 'px, 0)';
  }

  window.addEventListener('scroll', update, { passive: true });
})();
